import { gql } from "@apollo/client";

// ============================================================================
// NEARBY QUERIES
// ============================================================================

import { GENERAL_FIELDS, SITE_FIELDS, PAGE_SETTINGS, MUNICIPALITY_FIELDS } from "./shared";
import { SERVICE_FIELDS } from "./fragments/services";

export const MUNICIPALITY_INTRO_IMAGE = gql`
  fragment MunicipalityIntroImage on MunicipalityRecord {
    introImage {
      id
      responsiveImage(
        imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "500", h: "500", q: "75" }
      ) {
        alt
        height
        src
        title
        width
      }
    }
  }
`;

export const MUNICIPALITY_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${MUNICIPALITY_FIELDS}
  ${MUNICIPALITY_INTRO_IMAGE}
  ${SERVICE_FIELDS}

  query GetMunicipality($slug: String!, $locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: municipality(filter: { slug: { eq: $slug } }, locale: $locale) {
      # Municipality Meta (SEO)
      slugs: _allSlugLocales(locale: $locale) {
        locale
        value
      }
      titles: _allTitleLocales(locale: $locale) {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      blockSearchIndexing

      # Municipality Fields (Content)
      ...MunicipalityFields
      ...MunicipalityIntroImage
    }
    nearbyServices: allServices(
      locale: $locale
      first: 3
      orderBy: _createdAt_DESC
      filter: { _locales: { allIn: [$locale] } }
    ) {
      ...ServiceFields
      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "500", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }
    }
  }
`;

export const GET_NEARBY_DATA_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${SERVICE_FIELDS}
  ${PAGE_SETTINGS}
  query GetNearbyData($locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: nearbyOverview(locale: $locale) {
      # Nearby Overview Meta (SEO)
      titles: _allTitleLocales(locale: $locale) {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      blockSearchIndexing

      # Nearby Overview Fields (Content)
      title
      shortTitle
      intro {
        value
      }

      # Nearby Overview Intro Image
      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "1560", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }
      introImageMobile: introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "525", h: "375", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }

      # Nearby Overview Components
      pageSettings {
        ...PageSettings
      }

      highlightedServices {
        ...ServiceFields
        childrenServices: children {
          ...ServiceFields
          parent {
            slug
          }
        }
      }
    }
  }
`;
